<div class="quickbet-content srm-selection" [ngClass]="{ suspended: selection.disabled || isLogAndQuickBetPending }" data-crlat="quickbet.content">
    <div class="quickbet-sectionwrap">
        @if (isFullOverlay) {
            <section class="qb-full-overlay-selection-remove-btn">
                <div class="qb-remove-btn" data-crlat="selectionCloseButton" (click)="removeSelection()">
                    <svg>
                        <use xlink:href="#close-icon"></use>
                    </svg>
                </div>
            </section>
        }
        <section class="qb-content-info srm-content-info">
            <p class="outcome-name" [i18n]="'quickbet.sameRaceMulti'" data-crlat="selectionName"></p>
            @for (qa of selectedQuestionAndAnswers; track qa.question) {
                <p class="market-name" [textContent]="qa.question" data-uat="marketName"></p>
                <p class="event-name" [textContent]="qa.answer" data-uat="eventName"></p>
            }
        </section>

        <section id="quickBetEW" class="qb-stake-section" data-crlat="section.stake">
            <div class="qb-odds-stake-wrapper">
                <div class="odds">
                    <span class="odds-value" [textContent]="srmOdds" data-crlat="odds"></span>
                </div>
                <div class="stake" data-crlat="stake.amountInputForm">
                    <div>
                        <label
                            [ngClass]="selectionAmountClasses"
                            class="input-stake-label"
                            [attr.data-currency]="selection.currency"
                            [textContent]="selection.stake ? selection.currency : ''">
                        </label>
                        <input
                            #qbInputStake
                            id="stake-input"
                            class="stake-input"
                            placeholder="Stake"
                            [digit-keyboard-input]
                            [selectedFreeBet]="selectedFreeBet"
                            [freebetsList]="freebetsList"
                            (freeBetSelected)="onFreebetChange($event)"
                            [freebetsConfig]="freebetsConfig"
                            [isBoostEnabled]="isBoostEnabled"
                            [fanzoneList]="fanzoneList"
                            [betPackList]="betPackList"
                            [isSelectionBoosted]="this.selection.isBoostActive"
                            [canBoostSelection]="canBoostSelection"
                            [patternRestrict]="stakePattern"
                            [patternToFixed]="true"
                            [componentId]="isFullOverlay ? 'quickbet-updated-panel' : 'quickbet-panel'"
                            [showDecimalPoint]="true"
                            [value]="selection.stake"
                            [(ngModel)]="selection.stake"
                            (ngModelChange)="onStakeChange()"
                            [disabled]="
                                selection.disabled ||
                                isLogAndQuickBetPending ||
                                showPendingSpinner() ||
                                serviceClosureService.userServiceClosureOrPlayBreak
                            "
                            [eventAction]="'quickbet'"
                            data-money-validate="true"
                            data-crlat="value" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

<digit-keyboard
    [componentId]="isFullOverlay ? 'quickbet-updated-panel' : 'quickbet-panel'"
    [currency]="selection.currency"
    [hideKeyboardFlag]="false"
    [disabled]="selection.disabled || isLogAndQuickBetPending || showPendingSpinner() || serviceClosureService.userServiceClosureOrPlayBreak"
    (keyboardShown)="onKeyboardToggle(false)"
    (keyboardHidden)="onKeyboardToggle(true)"
    #qbDigitKeyboard>
</digit-keyboard>

<quick-stake
    [quickStakeVisible]="quickStakeVisible"
    [freebetsList]="freebetsList"
    [selectedFreeBet]="selectedFreeBet"
    [betPackList]="betPackList"
    [fanzoneList]="fanzoneList"
    [disabled]="selection.disabled || placeBetPending.state || isLogAndQuickBetPending || serviceClosureService.userServiceClosureOrPlayBreak"
    [freebetsConfig]="freebetsConfig"
    [isBoostEnabled]="isBoostEnabled"
    [isSelectionBoosted]="this.selection.isBoostActive"
    [canBoostSelection]="canBoostSelection"
    (quickStakeSelect)="onQuickStakeSelect($event)"
    (fbChange)="onFreebetChange($event)"
    data-crlat="quickStakePanel"
    [betslipType]="betslipType"
    [isFullOverlay]="isFullOverlay">
</quick-stake>

@if (maxPayedOut && maxPayFlag) {
    <lazy-component
        moduleUri="@lazy-modules-module/maxpayOutErrorContainer/maxpayout-error-container.module#MaxpayoutErrorContainerModule"
        [inputs]="{ betType: 'quick bet', errorMsg: maxPayMsg }"
        entryComponent="MaxpayoutErrorContainerComponent"
        data-crlat="maxPayout">
    </lazy-component>
}

<bet-summary
    [selection]="selection"
    [jump]="'jump'"
    (showMaxPayOutMessage)="addItem($event)"
    [maxPayOutValue]="selection.maxPayout"
    data-crlat="betSummary"></bet-summary>

<div class="quickbet-controls">
    @if (!isMakeQuickDeposit()) {
        <button
            class="qb-right-cta-btn srm-placebet-btn"
            [disabled]="disablePlaceBet || isLogAndQuickBetPending || serviceClosureService.userServiceClosureOrPlayBreak"
            (click)="placeBetFnHandler()"
            data-crlat="placeBetButton">
            @if (showPendingSpinner()) {
                <spinner></spinner>
            }
            @if (!showPendingSpinner() && isUserLoggedIn) {
                <span [i18n]="'quickbet.buttons.placeBet'"></span>
            }
            @if (showPendingSpinner() && isUserLoggedIn && selection.isStarted && countDownTimer) {
                <span>{{ countDownTimer.value }}</span>
            }
            @if (!showPendingSpinner() && !isUserLoggedIn) {
                <span [i18n]="'quickbet.buttons.loginPlaceBet'"></span>
            }
        </button>
    } @else {
        <button
            class="qb-right-cta-btn qb-quick-deposit-button srm-deposit-button"
            [disabled]="isSelectionDisabled()"
            (click)="openQuickDepositFnHandler()"
            data-crlat="quickDepositButton">
            @if (showSpinnerOnQuickDeposit()) {
                <spinner data-crlat="spinner.loader"></spinner>
            }
            <span [i18n]="'quickbet.buttons.makeQuickDeposit'"></span>
        </button>
    }
</div>
